<template>
    <div>
        <div class="nav primary-bg pl20 pr20 pt10 pb10">
            <div class="box-horizontal">
                <div class="" @click="met.back()">
                    <img src="@/assets/back.png" alt="" style="height:30px">
                </div>
                <div class="flex-1 f13 text-center white">
                    Bantuan
                </div>
                <div class=""></div>
            </div>
        </div>
        <div class="wrapper">
            <div class="body">
                <div class=" mt20 mb20 text-center hitam" v-show="!get.data.isSuccess">
                    Untuk melaporkan gangguan atau kendala lain. Anda dapat menggunakan fitur di bawah ini.
                </div>
                <div class=" mb20 text-center gray" v-show="!get.data.isSuccess">
                    - Lapor Langsung kepada Teknisi Kami -
                </div>
                <div class="mb20 bg-round-white pt20 pb20" v-show="!get.data.isSuccess">
                    <div class="dialog-inner ml10 mr10 text-right">
                        <span class="block mb10 text-left hitam">Keluhan Anda?</span>
                        <textarea class="w100 mb10" style="box-sizing: border-box;" rows="5" v-model="get.data.keluhan"></textarea>
                        <button class="btn btn-info" v-show="get.data.afterKlik" @click="get.data.afterKlik = false;met.simpan()">Submit</button>
                    </div>
                </div>

                <div class="mb20 bg-round-white pt20 pb20 text-center" v-show="get.data.isSuccess">
                    <img src="@/assets/cek.png" style="width: 75px;" />
                    <h3 class="mb5 mt10">Pengaduan Anda berhasil Terkirim</h3>
                    <span>Tunggu sebentar ya, kami akan segera proses</span>
                </div>

                <!--
                <div class="mb20 bg-round-white pt20 pb20" v-show="false">
                    <div class=" pl10 pr10 box-horizontal" v-for="(u, index) in get.data.list">
                        <div class="flex-1 pb5 bt-1" @click="get.data.dialog = true, get.data.nama = u.nama, get.data.telepon = u.hp, get.data.id = u.id">
                            <span class="block f13">{{u.nama}}</span>
                            <span class="block f10 gray">{{u.hp}}</span>
                        </div>
                        <img src="@/assets/chat-bubble.png" alt="" style="height:20px">
                    </div>
                </div>
                -->
            </div>
        </div>
    </div>
</template>

<script>
import myGlobal from '@/MyGlobal'
import { reactive } from '@vue/composition-api'
import store from '@/store/index'
import inter from '@/Interface'
import router from '@/router'
import Loading from '@/global/Loading' 

export default {
    setup() {
        const get = {
            data: reactive({
                this: '',
                list: [],
                dialog: false,
                keluhan: '',
                nama: '',
                telepon: '',
                id: '', // teknisi id
                isSuccess: false,
                afterKlik: true
            }),
            list() {
                var datax = {
                    token: 'TangTung '+sessionStorage.getItem("tokenu")
                };
            
                var apiUrl = inter.Bantuan(); 

                myGlobal.call(datax,apiUrl).then(x => {
                    //console.log(JSON.stringify(x));

                    if (x.status == true) {
                        this.data.list = x.data;
                    } else {
                        
                    }
                    
                })
            }
        }

        const met = {
            back() {
                window.history.back();
            },
            simpan() {
                if (get.data.keluhan == "") {
                    myGlobal.android("toast", "Keluhan tidak boleh kosong")
                    return false;
                }
                
                var waowner = null;
                if (sessionStorage.getItem("data_profil") != null) {
                    var d = JSON.parse(sessionStorage.getItem("data_profil"));
                    waowner = d.ahp;
                }

                //console.log(waowner);

                var datax = {
                    token: 'TangTung '+sessionStorage.getItem("tokenu"),
                    teks: get.data.keluhan,
                    //teknisi: "aaa",
                    //teknisiid: "11",
                    waowner: waowner
                };
                
                //console.log(JSON.stringify(datax));
            
                var apiUrl = inter.BantuanSave(); 

                myGlobal.call(datax,apiUrl).then(x => {
                    //console.log(JSON.stringify(x));

                    if (x.status == true) {
                        var params = {
                            nama: get.data.nama,
                            telepon: get.data.telepon,
                            teks: get.data.keluhan
                        }
                        // myGlobal.android("waBantuan", params);
                        
                        //myGlobal.android("toast", "Pengaduan Telah disimpan");
                        get.data.keluhan = "";
                        get.data.isSuccess = true;

                        get.data.dialog = false;
                        
                    } else {

                        myGlobal.android("toast", "Terjadi Kesalahan")
                        
                    }
                    
                })
            }
        }

        const redirectx = {
            checkApp() {
                myGlobal.checkApp();
            },
            now() {
                location.href="#/";
            }
        }

        return {
            get,
            redirectx,
            met
        }

    },
    mounted () {        
        this.redirectx.checkApp();

        this.get.list();
    }
}
</script>


// WEBPACK FOOTER //
// src/components/User/Bantuan/main.vue